import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const medicationApis = {
  getMedicationList: async (data?: any) => {
    return await request({
      method: methods.GET,
      route: "/gfc/patient_medication/list",
      payload: data,
    });
  },
  getMedicationById: async (data?: any) => {
    return await request({
      method: methods.GET,
      route: `/gfc/patient_medication/${data?.medication_id}`,
    });
  },
  addMedication: async (data?: any) => {
    return await request({
      method: methods.POST,
      route: "/gfc/patient_medication",
      payload: data,
    });
  },
  editMedication: async (data?: any) => {
    return await request({
      method: methods.PUT,
      route: "/gfc/patient_medication",
      payload: data,
    });
  },
  deleteMedication: async (data?: any) => {
    const route = `/gfc/patient_medication/${data?.medication_id}`;
    return await request({
      method: methods.DELETE,
      route,
    });
  },
  getMedicationLog: async (queryParams: Record<string, string | number>) => {
    const route = queryParams
      ? bindQueryParams("/gfc/loggers", queryParams)
      : "/gfc/logger";
    return await request({
      method: methods.GET,
      route,
      priv: true,
    });
  },
};

export default medicationApis;
